export enum ShipmentRequestsMultiplicationType {
  Single = 'SINGLE',
  Multiple = 'MULTIPLE'
}
